import { createContext } from 'react';

interface SingleNuclidesViewContextType {
	selectedNuclides: Array<string>,
	setSelectedNuclides: (singleNuclides:Array<string>) => void
}
export const SingleNuclidesViewContext = createContext<SingleNuclidesViewContextType|null>(null);

